// @flow
import * as React from 'react';
import { Route, Redirect } from 'react-router';
import type { ContextRouter, LocationShape } from 'react-router-dom';

export type StateProps = {|
  /** True to enable the rendering of the component */
  isEnabled: boolean
|};

type OwnProps = {|
  // from react-router-dom_v4.x.x.js
  component: React$ComponentType<*>,
  render?: (router: ContextRouter) => React$Node,
  children?: React$ComponentType<ContextRouter> | React$Node,
  path?: string,
  exact?: boolean,
  strict?: boolean,
  location?: LocationShape,
  sensitive?: boolean
|};

type Props = StateProps & OwnProps;

const ProtectedRoute = ({
  component: Component,
  isEnabled,
  ...routeProps
}: Props) => {
  // eslint-disable-next-line react/no-multi-comp
  function render(props: ContextRouter) {
    if (isEnabled) {
      return <Component {...routeProps} {...props} />;
    }
    return <Redirect to={`/${props.location.search}`} />;
  }
  return <Route {...routeProps} render={render} />;
};

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/components/common/router/ProtectedRoute.js